import React from "react";

const SvgSortingUp = props => (
  <svg viewBox="0 0 242 209" {...props}>
    <g data-name="Vrstva 2">
      <g data-name="Obecn\xE9 ikony">
        <g data-name="Sorting up">
          <path data-name="&lt;\u0158ez&gt;" fill="none" d="M0 0h242v209H0z" />
          <path
            data-name="Sorting up"
            d="M54.81 12.28a7.31 7.31 0 00-5.12 2.14h-.09s-.05.1-.09.14L13.7 49.92a7.35 7.35 0 00-2.23 5.21 7.45 7.45 0 002.14 5.26 7.36 7.36 0 0010.39.09L47.42 37.4l.22 152.79a7.4 7.4 0 0014.79 0l-.22-152.61 22.94 23.34A7.4 7.4 0 0095.7 50.54l-35.54-36a7.53 7.53 0 00-5.22-2.23zm80.05 21.38a7.13 7.13 0 000 14.26h89.4a7.13 7.13 0 000-14.26zm0 42.76a7.13 7.13 0 000 14.26h89.4a7.13 7.13 0 000-14.26zm-33.5 42.77a7.13 7.13 0 100 14.25h122.9a7.13 7.13 0 000-14.25zm0 42.76a7.13 7.13 0 100 14.25h122.9a7.13 7.13 0 000-14.25z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgSortingUp;
